<template>
  <div class="the-content-container single-article__post-content">
    <TheContent
      v-for="item of separatedContent.content"
      :key="item.id"
      :elem="item"
    />
  </div>
</template>

<script setup lang="ts">
  import TheContent from '~/components/content/TheContent';
  import separateScriptsAndContent from '~/libs/separateScriptsAndContent';
  import { Scripts } from '~/libs/Scripts';
  import { useIndexStore } from '~/store';

  defineOptions({
    name: 'HtmlWidgetContainer',
  });

  const props = defineProps({
    widgetsArray: {
      type: Array as PropType<TContent[]>,
      required: true,
    },
    location: {
      type: String as PropType<string | null>,
      default: null,
    },
  });

  const separatedContent = computed(() => separateScriptsAndContent(props.widgetsArray));
  const indexStore = useIndexStore();

  watch(
    () => indexStore.isHeadScriptsLoaded,
    (isLoaded) => {
      if (!isLoaded) return;
      if (!separatedContent.value.scripts.length && !separatedContent.value.inlineScripts.length)
        return;

      const { scripts, inlineScripts } = separatedContent.value;
      new Scripts(scripts, inlineScripts).addScripts();
    },
    { immediate: true },
  );
</script>

<style lang="scss" scoped>
  .the-content-container {
    @mixin padding {
      padding: 0 16px;
      @include tablet {
        padding: 0 24px;
      }
    }

    @include widget-between-posts {
      max-width: 100vw;
      margin: 0;
      padding: 0 16px;
    }

    @include widget-below-comments {
      @include padding;

      div[id^='adfox_'] {
        margin: 0 -16px;

        @include tablet {
          margin: 0 -24px;
        }
      }
    }

    @include widget-footer {
      @include padding;

      div[id^='adfox_'] {
        margin: 0 -16px;

        @include tablet {
          margin: 0 -24px;
        }
      }
    }
  }
</style>

<style lang="scss">
  .the-content-container {
    div[id*='adfox_'] {
      overflow: hidden;
      display: flex;
      justify-content: center;

      // для сброса
      // iframe {
      // border: none;
      // width: 1px;
      // min-width: 100%;
      // }
      // из _base.scss
      // fix LH-1193
      iframe {
        border: inherit;
        width: inherit;
        min-width: inherit;
      }

      // fix LH-1285
      a {
        border: none !important;
      }
    }
  }
</style>
